/**
 * Calendar-day helpers: local UI dates vs naive API dates (YYYY-MM-DD).
 * Shared by client (via webpack) and Node tests.
 */

function ymdFromLocalCalendarDate(d) {
  if (!d || Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

function ymdFromApiDate(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") {
    const t = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t;
    if (/^\d{4}-\d{2}-\d{2}T/.test(t)) return t.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}/.test(t)) return t.slice(0, 10);
    return "";
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  return "";
}

function formatDateForInput(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") {
    const t = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t;
    if (/^\d{4}-\d{2}-\d{2}T/.test(t)) return t.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}/.test(t)) return t.slice(0, 10);
    return "";
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return ymdFromLocalCalendarDate(value);
  }
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  return "";
}

module.exports = {
  ymdFromLocalCalendarDate,
  ymdFromApiDate,
  formatDateForInput,
};
